import { render } from "./pageRender.vue?vue&type=template&id=b5e572d0"
import script from "./pageRender.vue?vue&type=script&lang=js"
export * from "./pageRender.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mathieu/conductor/workspaces/miakapp-v3/lima-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__